/**
 * Color palette for the ProfitStacks application
 * CMMI-based rating colors
 */

export const RATING_COLORS = {
  chaotic: "#f44336", // Red - Level 0
  reactive: "#ff9800", // Orange - Level 1
  proactive: "#ffeb3b", // Yellow - Level 2
  strategic: "#2196f3", // Blue - Level 3
  profit: "#4caf50", // Green - Level 4
} as const;

export const RATING_COLORS_LIGHT = {
  chaotic: "#ffcdd2", // Light Red
  reactive: "#ffe0b2", // Light Orange
  proactive: "#fff9c4", // Light Yellow
  strategic: "#bbdefb", // Light Blue
  profit: "#c8e6c9", // Light Green
} as const;

/**
 * Stack header colors (subtle differentiation)
 */
export const STACK_COLORS = {
  Sales: "#e3f2fd", // Light Blue
  People: "#fce4ec", // Light Pink
  Production: "#e8f5e9", // Light Green
  Finance: "#fff3e0", // Light Orange
  Structure: "#f3e5f5", // Light Purple
} as const;

/**
 * UI Colors
 */
export const UI_COLORS = {
  background: "#fafafa",
  surface: "#ffffff",
  border: "#e0e0e0",
  text: {
    primary: "#212121",
    secondary: "#757575",
    disabled: "#9e9e9e",
  },
  action: {
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "rgba(0, 0, 0, 0.08)",
  },
} as const;
